






































































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Address } from '@/store/consumer-application/types';
import { requiredRule, characterCountRule, stateExclusionRule, under19AlabamaRule, onlyLettersNumbersApostrophesHyphensAndSpacesAllowedRule, onlyNumbersAllowedRule } from '@/form-rules';

@Component
export default class AddressFields extends Vue {
    address: Address = {
        streetAddress: '',
        streetAddress2: '',
        city: '',
        state: '',
        zip: '',
        mailingAddressChecked: false,
        mailingStreetAddress: '',
        mailingStreetAddress2: '',
        mailingCity: '',
        mailingState: '',
        mailingZip: '',
	};

	mailingAddressChecked = false;

	streetAddressRules = [
		requiredRule('Street Address is required'),
		characterCountRule('Street Address', 40),
		onlyLettersNumbersApostrophesHyphensAndSpacesAllowedRule(),
	];
	streetAddress2Rules = [
		characterCountRule('Street Address 2', 40),
		onlyLettersNumbersApostrophesHyphensAndSpacesAllowedRule(),
	];
	cityRules = [
		requiredRule('City is required'),
		characterCountRule('City', 20),
		onlyLettersNumbersApostrophesHyphensAndSpacesAllowedRule(),
	];
	stateRules = [
		requiredRule('State is required'),
		stateExclusionRule('The selected state is not eligible for this offer.'),
		under19AlabamaRule('You must be at least 18 years of age to apply, or 19 years of age if residing in Alabama',
			this.$store.getters['consumerApplication/consumerApplication'].identity.dateOfBirth),
	];
	zipRules = [
		requiredRule('Zip is required'),
		characterCountRule('Zip', 5),
		onlyNumbersAllowedRule(),
	];
	mailingStreetAddressRules = [
		requiredRule('Street Address is required'),
		characterCountRule('Mailing Street Address', 40),
		onlyLettersNumbersApostrophesHyphensAndSpacesAllowedRule(),
	]
	mailingStreetAddress2Rules = [
		characterCountRule('Street Address 2', 40),
		onlyLettersNumbersApostrophesHyphensAndSpacesAllowedRule(),
	];
	mailingCityRules = [
		requiredRule('City is required'),
		characterCountRule('City', 20),
		onlyLettersNumbersApostrophesHyphensAndSpacesAllowedRule(),
	]
	mailingStateRules = [
		requiredRule('State is required'),
	];
	mailingZipRules = [
		requiredRule('Zip is required'),
		characterCountRule('Zip', 5),
		onlyNumbersAllowedRule(),
	];

	updateAddress () {
		this.$store.commit('consumerApplication/SET_ADDRESS_FIELDS', this.address, { root: true });
	}

	get dateOfBirth() {
		return this.$store.getters['consumerApplication/consumerApplication'].identity.dateOfBirth;
	}

	@Watch('dateOfBirth')
	async validateState(dateOfBirth: string) {
		this.stateRules = [
				requiredRule('State is required'),
				stateExclusionRule('The selected state is not eligible for this offer.'),
				under19AlabamaRule('You must be at least 18 years of age to apply, or 19 years of age if residing in Alabama',
					dateOfBirth),
			];

		await this.$nextTick();
		(this.$refs.state as any & { validate: () => boolean }).validate();
	}
}
